/**
 * RowAction: an icon button for a table row whose accessible name includes the record, e.g. Delete "Pho bo".
 * Props: `action` (translated verb), `record` (the record's label), `icon`, `onClick`, `kind` (default ghost).
 */
import { IconButton } from '@carbon/react';
import type { CarbonIconType } from '@carbon/icons-react';
import { useTranslation } from '@pos/i18n';

export function RowAction({
  action,
  record,
  icon: Icon,
  onClick,
  kind = 'ghost',
}: {
  action: string;
  record: string;
  icon: CarbonIconType;
  onClick(): void;
  kind?: 'ghost' | 'tertiary';
}) {
  const { t } = useTranslation();
  return (
    <IconButton kind={kind} label={t('admin.rowAction', { action, record })} onClick={onClick}>
      <Icon />
    </IconButton>
  );
}
